jQuery(document).ready(function($){
    //Add aria label to mega menu links
    $('.mega-menu-promotion[href="/collections/plant-milks"]').attr('aria-label', "New unsweetened plant milks, shop");
    $('.mega-menu-promotion[href="/pages/store-locator"]').attr('aria-label', "Only in stores, get it before it’s gone, store locator");
    $('.flickity-next').attr("aria-label", "next slide");
    $('.flickity-prev').attr("aria-label", "previous slide");
    $('slide-show').removeAttr('tabindex');

    $('.flickity-slider .product-card--add-to-cart-button').attr('tabindex', '0').attr('role', 'button').attr('title', 'Opens dialog');

    $('.collection-tabs__list .collection-tabs__list-link').attr('role', 'tab').removeAttr('type').click(function(){
        $('.collection-tabs__list .collection-tabs__list-link').attr('aria-selected', "false");
        $(this).attr('aria-selected', "true");
    });

    $('.collection-tabs__list .collection-tabs__list-link').each(function(){
        if($(this).hasClass('active')){
            $(this).attr('aria-selected', "true");
        }
    })

    $('.before-after-image--slider').focus(function(){
        $(this).prev().addClass('focus');
    })

    $('.before-after-image--slider').blur(function(){
        $(this).prev().removeClass('focus');
    })

    //update button in footer
    $('.footer .medium-3 .thb-widget-title').each(function(){
        $(this).next().attr('aria-label', $(this).text());
        $(this).replaceWith($('<div class="thb-widget-title collapsible">' + $(this).html() + '</div>'));
    })

    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
            button.addEventListener('click', (e) => {
                button.classList.toggle('active');
            });
        });

    $('.badge.out-of-stock').each(function(){
        $(this).closest('.product-card').find('a').attr('title',$(this).closest('.product-card').find('a').attr('title')  + ' (Sold Out)');
    })

    $('.badge.new').each(function(){
        $(this).closest('.product-card').find('a').attr('title',$(this).closest('.product-card').find('a').attr('title')  + ' (New)');
    })

    $('.side-panel').attr('role', 'dialog').attr('aria-model', 'true');

    $('.order-note-toggle').attr('tabindex', '0');
    $('.side-panel-close').attr('tabindex', '0').attr('aria-label','Close cart slide in');

    $(document).click(function(){
        if($('.order-note-toggle__content').hasClass('active')){
            $('.order-note-toggle__content').attr('aria-expanded', 'true');
        }
        else{
            $('.order-note-toggle__content').attr('aria-expanded', 'false');
        }

        $('.facet-drawer input').attr('aria-hidden', 'true');
        $('.facet-drawer.active input').attr('aria-hidden', 'false');

        $('.product-cart-item-info .remove').attr('aria-label', 'Delete, ' + $('.product-cart-item-info .remove').closest('.product-cart-item').find('.cart-product-link').html())
    })

    $('.order-note-toggle__content button').attr('tabindex', '0').attr('role', 'button');
    $('.cart-drawer-footer button').attr('tabindex', '0').attr('role', 'button');

    $('.mobile-toggle').attr('aria-label', 'menu');

    $('a[title="Find Your Costco"]').attr('aria-label', 'PDF opens new window');

    $('.search-field').attr('aria-label','Search for anything')

    $('.product-thumbnail').attr('role', 'button').attr('tabindex', '0').attr('aria-label', 'set to large front view of product')

    $('.product-thumbnail').each(function(){
        var label = "Set to large view of " + $(this).find('img').attr('alt');
        $(this).attr('aria-label', label)
    });

    $('.thb-filter-count mobile-filter-count body-font').attr('role', 'status');

    $('quantity-selector input').attr('role','status');

    $('.product-cart-item-info .price').attr('role','status');

    $('.template-cart .cart-items').attr('aria-label', 'your cart products');
    $('#shopify-subscription-policy-button').replaceWith($('<a id="shopify-subscription-policy-button" role="button">' + $('#shopify-subscription-policy-button').html() + '</a>'));

    $('.template-cart .checkout-button').attr('aria-describedby', 'shopify-buyer-consent');

    $('.flickity-slider-pause').click(function(){
        $(this).parent().toggleClass('paused');
    })

    const elementsToWatch = document.querySelectorAll('.side-panel, .order-note-toggle__content', '.cart-section');

    $('.side-panel.facet-drawer').attr('tabindex', '-1');

    $('.thb-filter-count.mobile-filter-count.body-font').attr('role', 'status');

    $('.price .amount').attr('role', 'status');

    $('.checkout-button').attr('role', 'status');

    $('.cart-items th').attr('scope', 'col');

    const callback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                //role class 
                $('.cart-items quantity-selector input').attr('role', 'status');
                $('.cart-items .price .amount').attr('role', 'status');
                $('.cart-items .checkout-button').attr('role', 'status');

                $('#shopify-subscription-policy-button').replaceWith($('<a id="shopify-subscription-policy-button" role="button">' + $('#shopify-subscription-policy-button').html() + '</a>'));
                if (mutation.target.classList.contains('active')) {
                    console.log("Dialog open");
                    $(".side-panel.active").attr('tabindex', '-1');
                    $(".side-panel.active").focus();
                    $(".side-panel-close").attr('tabindex', '0');

                    if($(mutation.target).hasClass('privy-widget-campaign-4389551')){
                        $(mutation.target).find('input[type="email"]').parent().prepend("<label>Enter your email address...</label>");
                        $(mutation.target).find('input[type="email"]').attr('aria-label', 'Enter your email address...');
                    }

                
                    
                    $("cart-drawer .side-panel-close").attr('aria-label', 'Close cart slide in');
                    $(".product-drawer .side-panel-close").attr('aria-label', 'Close product drawer slide in');
                    $("cart-drawer button").attr('role', 'button');
                    $('.facet-drawer .side-panel-close').attr('aria-label', 'Close filter drawer slide in');

                    //Role status stuff
                    $(".side-panel-content .amount div").attr('role', 'status');
                    $(".side-panel-content .checkout-button").attr('role', 'status');
                    $('cart-drawer quantity-selector input').attr('role', 'status');

                    $('.order-note-toggle__content button').attr('tabindex', '-1');
                    
                    if($(mutation.target).hasClass('order-note-toggle__content')){
                        console.log("opened note");
                        $('.order-note-toggle__content button').attr('tabindex', '0').attr('role', 'button');
                    }

                    if($(mutation.target).attr('id') == "Product-Drawer"){
                        $(mutation.target).find('.product-quick-images').attr('tabindex', '-1');
                        $(mutation.target).find('input[name="quantity"]').attr('role', 'status');
                        $(mutation.target).find('.product-popup-modal__opener').remove();
                    }

                    $(".side-panel-close").keydown(function(event) {
                        if (event.which === 13) {
                            $(".side-panel-close").click();
                        }
                    });
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    const config = { attributes: true };
    elementsToWatch.forEach(element => {
        observer.observe(element, config);
    });
});